export default function saveUserCookies(
  userId,
  name,
  companyId,
  email,
  picture,
  roles,
  parentCompanyId
) {
  const currentMillis = new Date().getTime() + 30 * 60 * 60 * 1000;
  const utcDate = new Date(currentMillis).toUTCString();
  document.cookie = 'user_id =' + userId + ';expires=' + utcDate;
  document.cookie = 'name =' + name + ';expires=' + utcDate;
  document.cookie = 'companyId =' + companyId + ';expires=' + utcDate;
  document.cookie = 'email =' + email + ';expires=' + utcDate;
  document.cookie = 'picture =' + picture + ';expires=' + utcDate;
  document.cookie = 'roles=' + roles.join(',') + ';expires=' + utcDate;
  document.cookie = 'parentCompanyId=' + parentCompanyId + ';expires=' + utcDate;
}
